import catalog from './catalog.json'

export const servicePaths = ['/services', ...catalog.map(service => `/services/${service.slug}`)]
export function serviceMetadata(path: string) {
  const pathname = path.replace(/\/$/, '')
  const service = catalog.find(item => pathname === `/services/${item.slug}`)
  return {
    title: service ? `${service.name} — Dugout` : 'Strategy, Brand & Growth Services — Dugout',
    description: service?.description ?? 'Brand strategy, product direction, content, community and business enablement for founders and small teams. Explore Dugout’s services and focused engagements.',
    canonical: `https://godugout.com${pathname || '/services'}`,
  }
}

export function serviceSchema(path: string) {
  const meta = serviceMetadata(path)
  const service = catalog.find(item => meta.canonical.endsWith(`/services/${item.slug}`))
  const crumbs = [{ name: 'Home', item: 'https://godugout.com/' }, { name: 'Services', item: 'https://godugout.com/services' }]
  const parent = service?.parent && catalog.find(item => item.slug === service.parent)
  if (parent) crumbs.push({ name: parent.name, item: `https://godugout.com/services/${parent.slug}` })
  if (service) crumbs.push({ name: service.name, item: meta.canonical })
  return {
    '@context': 'https://schema.org',
    '@graph': [
      { '@type': service ? 'WebPage' : 'CollectionPage', '@id': `${meta.canonical}#page`, url: meta.canonical, name: meta.title, description: meta.description, inLanguage: 'en' },
      { '@type': 'BreadcrumbList', itemListElement: crumbs.map((crumb, index) => ({ '@type': 'ListItem', position: index + 1, ...crumb })) },
      service
        ? { '@type': 'Service', name: service.name, serviceType: service.name, description: service.description, url: meta.canonical, provider: { '@type': 'Organization', name: 'Dugout', url: 'https://godugout.com/' } }
        : { '@type': 'ItemList', itemListElement: catalog.filter(item => !item.parent).map((item, index) => ({ '@type': 'ListItem', position: index + 1, name: item.name, url: `https://godugout.com/services/${item.slug}` })) },
    ],
  }
}
